var version = "3.0.5";
export { version as default };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_xgplayer@3.0.5@xgplayer/es/version.js
// module id = null
// module chunks = 